export const repairMessages = {
  fr: {
    reservation: 'Collecte réservée', recoverHint: 'Changez le livreur ou annulez la réservation avant la remise. Il faut indiquer une raison.', release: 'Annuler la réservation', recover: 'Changer la réservation', reason: 'Raison', reservationSaved: 'Réservation modifiée.',
    acceptPickup: 'Accepter cette collecte', acceptReturn: 'Accepter ce retour', accepted: 'Collecte acceptée', releaseReturn: 'Laisser ce retour aux autres', returnReleased: 'Ce retour est disponible pour les autres livreurs.',
    acceptHint: 'Acceptez avant de partir. Cette collecte sera réservée pour vous.',
    reservedHint: 'Cette collecte est réservée pour vous. Confirmez ensuite la remise avec la photo et votre position.',
    senderHandover: 'Remise par l’expéditeur', senderHandoverHint: 'Appelez l’expéditeur, vérifiez le colis et sa référence, puis confirmez avec une photo et votre position.',
    returnPickup: 'Récupérer le retour', returnDestination: 'Rendre le colis',
    directReturn: 'Le colis est encore au point de départ. Rendez-le directement à l’expéditeur avec son nouveau code.',
    paymentTitle: 'Paiement de l’envoi', paymentDemo: 'Démonstration : aucun argent réel n’est pris.',
    paymentHint: 'Le vrai paiement sera ajouté plus tard. Cette démonstration accepte toute saisie, enregistre les frais et montre le code, sans prendre d’argent.',
    paymentGateHint: 'Cette démonstration accepte toute saisie et montre votre code après avoir enregistré les frais. Aucun vrai paiement.',
    previewPayment: 'Voir le formulaire de paiement', cardNumber: 'Numéro de carte', cardHolder: 'Nom sur la carte', expiry: 'Date d’expiration', securityCode: 'Code de sécurité',
    demoHolder: 'CARTE DE DÉMONSTRATION', simulatePayment: 'Tester le paiement de {amount}',
    paymentComplete: 'Démonstration terminée', paymentCompleteHint: 'Aucun vrai paiement n’a été fait. Les frais sont seulement notés.',
    payForCode: 'Payer pour voir le code', paymentRequired: 'Payez les frais pour recevoir votre code de dépôt.', paymentReceipt: 'Paiement de démonstration noté dans votre historique.', paymentFailed: 'Le paiement de démonstration a échoué. Réessayez.',
    shipment: 'Colis', amount: 'Montant', back: 'Retour', next: 'Suivant', review: 'Vérifier',
    originStep: 'Expéditeur et collecte', recipientStep: 'Destinataire', optionsStep: 'Détails du colis', reviewStep: 'Vérification',
    senderMap: 'Placer l’adresse sur la carte', senderMapHint: 'Touchez la carte ou déplacez le repère. Gardez une adresse claire pour le livreur.',
    locationSelected: 'Position choisie', change: 'Changer', step: 'Étape {current} sur {total}',
    pay: {
      secure: 'Paiement sécurisé',
      summary: 'Récapitulatif',
      fee: 'Frais de dépôt',
      total: 'Total à payer',
      method: 'Moyen de paiement',
      methodCard: 'Carte bancaire',
      methodCardHint: 'Visa, Mastercard, CMI',
      appleHint: 'Avec Face ID ou Touch ID',
      googleHint: 'Avec votre compte Google',
      paypalHint: 'Avec votre compte PayPal',
      holderPlaceholder: 'Nom comme sur la carte',
      errNumber: 'Numéro de carte invalide',
      errHolder: 'Saisissez le nom du titulaire',
      errExpiry: 'Date invalide',
      errExpired: 'Carte expirée',
      errCvc: 'Code invalide',
      useDemoCard: 'Utiliser la carte de démonstration',
      demoCardHint: 'Carte de test : 4242 4242 4242 4242, toute date future, tout code. Le numéro 4000 0000 0000 0002 simule un refus.',
      payNow: 'Payer {amount}',
      payWith: 'Payer avec {method}',
      contacting: 'Connexion à votre banque…',
      securing: 'Vérification sécurisée…',
      authenticating: 'Authentification avec {method}…',
      redirecting: 'Redirection vers PayPal…',
      waitingPaypal: 'En attente de l’approbation PayPal…',
      processing: 'Traitement du paiement…',
      verifyTitle: 'Vérification 3-D Secure',
      verifyHint: 'Saisissez le code à 6 chiffres envoyé par votre banque. En démonstration, tout code à 6 chiffres est accepté.',
      verifyCode: 'Code de vérification',
      verifyConfirm: 'Confirmer',
      errCode: 'Saisissez 6 chiffres',
      paypalTitle: 'Connexion à PayPal',
      paypalIntro: 'Connectez-vous pour approuver ce paiement de {amount}.',
      paypalEmail: 'E-mail PayPal',
      errEmail: 'Adresse e-mail invalide',
      paypalApprove: 'Se connecter et approuver',
      declined: 'Carte refusée par la banque. Essayez une autre carte.',
      receiptTitle: 'Paiement réussi',
      receiptHint: 'Votre code de dépôt est prêt.',
      paidWith: 'Payé avec',
      transaction: 'Transaction',
      date: 'Date',
      showCode: 'Afficher mon code',
      cardEnding: '{brand} •••• {last4}',
      paypalPaid: 'PayPal · {email}'
    }
  },
  en: {
    reservation: 'Reserved pickup', recoverHint: 'Change the courier or cancel the reservation before the hand-over. A reason is required.', release: 'Cancel the reservation', recover: 'Change the reservation', reason: 'Reason', reservationSaved: 'Reservation changed.',
    acceptPickup: 'Accept this pickup', acceptReturn: 'Accept this return', accepted: 'Pickup accepted', releaseReturn: 'Leave this return to others', returnReleased: 'This return is open to other couriers.',
    acceptHint: 'Accept before you go. This pickup will be kept for you.',
    reservedHint: 'This pickup is kept for you. Then confirm the hand-over with a photo and your location.',
    senderHandover: 'Hand-over by the sender', senderHandoverHint: 'Call the sender, check the parcel and its reference, then confirm with a photo and your location.',
    returnPickup: 'Pick up the return', returnDestination: 'Give the parcel back',
    directReturn: 'The parcel is still at the starting point. Give it straight back to the sender with their new code.',
    paymentTitle: 'Payment for the parcel', paymentDemo: 'Demo: no real money is taken.',
    paymentHint: 'Real payment will be added later. This demo accepts anything you type, records the fee and shows the code, without taking money.',
    paymentGateHint: 'This demo accepts anything you type and shows your code after recording the fee. No real payment.',
    previewPayment: 'See the payment form', cardNumber: 'Card number', cardHolder: 'Name on the card', expiry: 'Expiry date', securityCode: 'Security code',
    demoHolder: 'DEMO CARD', simulatePayment: 'Test the payment of {amount}',
    paymentComplete: 'Demo finished', paymentCompleteHint: 'No real payment was made. The fee is only recorded.',
    payForCode: 'Pay to see the code', paymentRequired: 'Pay the fee to get your drop-off code.', paymentReceipt: 'Demo payment noted in your history.', paymentFailed: 'The demo payment failed. Try again.',
    shipment: 'Parcel', amount: 'Amount', back: 'Back', next: 'Next', review: 'Check',
    originStep: 'Sender and pickup', recipientStep: 'Recipient', optionsStep: 'Parcel details', reviewStep: 'Check',
    senderMap: 'Put the address on the map', senderMapHint: 'Tap the map or move the pin. Keep a clear address for the courier.',
    locationSelected: 'Location chosen', change: 'Change', step: 'Step {current} of {total}',
    pay: {
      secure: 'Secure payment',
      summary: 'Summary',
      fee: 'Drop-off fee',
      total: 'Total to pay',
      method: 'Payment method',
      methodCard: 'Bank card',
      methodCardHint: 'Visa, Mastercard, CMI',
      appleHint: 'With Face ID or Touch ID',
      googleHint: 'With your Google account',
      paypalHint: 'With your PayPal account',
      holderPlaceholder: 'Name as shown on the card',
      errNumber: 'Invalid card number',
      errHolder: 'Enter the cardholder name',
      errExpiry: 'Invalid date',
      errExpired: 'Card expired',
      errCvc: 'Invalid code',
      useDemoCard: 'Use the demo card',
      demoCardHint: 'Test card: 4242 4242 4242 4242, any future date, any code. The number 4000 0000 0000 0002 simulates a decline.',
      payNow: 'Pay {amount}',
      payWith: 'Pay with {method}',
      contacting: 'Contacting your bank…',
      securing: 'Verifying securely…',
      authenticating: 'Authenticating with {method}…',
      redirecting: 'Redirecting to PayPal…',
      waitingPaypal: 'Waiting for PayPal approval…',
      processing: 'Processing payment…',
      verifyTitle: '3-D Secure verification',
      verifyHint: 'Enter the 6-digit code sent by your bank. In the demo any 6-digit code is accepted.',
      verifyCode: 'Verification code',
      verifyConfirm: 'Confirm',
      errCode: 'Enter 6 digits',
      paypalTitle: 'Log in to PayPal',
      paypalIntro: 'Log in to approve this payment of {amount}.',
      paypalEmail: 'PayPal email',
      errEmail: 'Invalid email address',
      paypalApprove: 'Log in and approve',
      declined: 'Your bank declined the card. Try another card.',
      receiptTitle: 'Payment successful',
      receiptHint: 'Your drop-off code is ready.',
      paidWith: 'Paid with',
      transaction: 'Transaction',
      date: 'Date',
      showCode: 'Show my code',
      cardEnding: '{brand} •••• {last4}',
      paypalPaid: 'PayPal · {email}'
    }
  },
  ar: {
    reservation: 'جمع محجوز', recoverHint: 'غيّر الموزّع أو ألغِ الحجز قبل التسليم. يجب ذكر السبب.', release: 'إلغاء الحجز', recover: 'تغيير الحجز', reason: 'السبب', reservationSaved: 'تم تغيير الحجز.',
    acceptPickup: 'قبول هذا الجمع', acceptReturn: 'قبول هذا الإرجاع', accepted: 'تم قبول الجمع', releaseReturn: 'ترك هذا الإرجاع لغيرك', returnReleased: 'أصبح هذا الإرجاع متاحا لموزّعين آخرين.',
    acceptHint: 'اقبل قبل الانطلاق. سيُحجز هذا الجمع لك.', reservedHint: 'هذا الجمع محجوز لك. بعدها أكد التسليم بالصورة وموقعك.',
    senderHandover: 'التسليم من المرسل', senderHandoverHint: 'اتصل بالمرسل وتحقق من الطرد ومرجعه ثم أكد بالصورة وموقعك.',
    returnPickup: 'أخذ المرتجع', returnDestination: 'إعادة الطرد', directReturn: 'الطرد ما زال في نقطة الانطلاق. أعده مباشرة إلى المرسل بالرمز الجديد.',
    paymentTitle: 'دفع ثمن الإرسال', paymentDemo: 'نسخة تجريبية: لا يُخصم أي مبلغ حقيقي.',
    paymentHint: 'سيُضاف الدفع الحقيقي لاحقا. هذه النسخة تقبل أي بيانات وتسجل الرسوم وتُظهر الرمز دون خصم مبلغ.',
    paymentGateHint: 'تقبل هذه النسخة أي بيانات وتُظهر رمزك بعد تسجيل الرسوم. لا يوجد دفع حقيقي.',
    previewPayment: 'عرض نموذج الدفع', cardNumber: 'رقم البطاقة', cardHolder: 'الاسم على البطاقة', expiry: 'تاريخ الانتهاء', securityCode: 'رمز الأمان',
    demoHolder: 'بطاقة تجريبية', simulatePayment: 'تجربة دفع {amount}', paymentComplete: 'انتهت التجربة', paymentCompleteHint: 'لم يتم أي دفع حقيقي. الرسوم مسجلة فقط.',
    payForCode: 'ادفع لرؤية الرمز', paymentRequired: 'ادفع الرسوم لتحصل على رمز الإيداع.', paymentReceipt: 'تم تسجيل الدفع التجريبي في سجلك.', paymentFailed: 'فشل الدفع التجريبي. حاول مرة أخرى.',
    shipment: 'الطرد', amount: 'المبلغ', back: 'رجوع', next: 'التالي', review: 'مراجعة',
    originStep: 'المرسل والجمع', recipientStep: 'المستلم', optionsStep: 'تفاصيل الطرد', reviewStep: 'المراجعة',
    senderMap: 'تحديد العنوان على الخريطة', senderMapHint: 'المس الخريطة أو حرّك العلامة. اترك عنوانا واضحا للموزّع.',
    locationSelected: 'تم اختيار الموقع', change: 'تغيير', step: 'الخطوة {current} من {total}',
    pay: {
      secure: 'دفع آمن',
      summary: 'الملخص',
      fee: 'رسوم الإيداع',
      total: 'المبلغ الإجمالي',
      method: 'طريقة الدفع',
      methodCard: 'بطاقة بنكية',
      methodCardHint: 'Visa وMastercard وCMI',
      appleHint: 'بواسطة Face ID أو Touch ID',
      googleHint: 'بواسطة حساب Google',
      paypalHint: 'بواسطة حساب PayPal',
      holderPlaceholder: 'الاسم كما هو على البطاقة',
      errNumber: 'رقم البطاقة غير صالح',
      errHolder: 'أدخل اسم حامل البطاقة',
      errExpiry: 'تاريخ غير صالح',
      errExpired: 'البطاقة منتهية',
      errCvc: 'رمز غير صالح',
      useDemoCard: 'استخدام البطاقة التجريبية',
      demoCardHint: 'بطاقة اختبار: 4242 4242 4242 4242 وأي تاريخ مستقبلي وأي رمز. الرقم 4000 0000 0000 0002 يحاكي الرفض.',
      payNow: 'ادفع {amount}',
      payWith: 'الدفع عبر {method}',
      contacting: 'جارٍ الاتصال ببنكك…',
      securing: 'جارٍ التحقق الآمن…',
      authenticating: 'جارٍ التوثيق عبر {method}…',
      redirecting: 'جارٍ التحويل إلى PayPal…',
      waitingPaypal: 'في انتظار موافقة PayPal…',
      processing: 'جارٍ معالجة الدفع…',
      verifyTitle: 'التحقق عبر 3-D Secure',
      verifyHint: 'أدخل الرمز المكوّن من 6 أرقام الذي أرسله بنكك. في النسخة التجريبية يُقبل أي رمز من 6 أرقام.',
      verifyCode: 'رمز التحقق',
      verifyConfirm: 'تأكيد',
      errCode: 'أدخل 6 أرقام',
      paypalTitle: 'تسجيل الدخول إلى PayPal',
      paypalIntro: 'سجّل الدخول للموافقة على هذه الدفعة بقيمة {amount}.',
      paypalEmail: 'بريد PayPal الإلكتروني',
      errEmail: 'بريد إلكتروني غير صالح',
      paypalApprove: 'تسجيل الدخول والموافقة',
      declined: 'رفض البنك البطاقة. جرّب بطاقة أخرى.',
      receiptTitle: 'تم الدفع بنجاح',
      receiptHint: 'رمز الإيداع جاهز.',
      paidWith: 'تم الدفع عبر',
      transaction: 'العملية',
      date: 'التاريخ',
      showCode: 'إظهار الرمز',
      cardEnding: '{brand} •••• {last4}',
      paypalPaid: 'PayPal · {email}'
    }
  },
  ma: {
    reservation: 'جمع محجوز', recoverHint: 'بدل الليفرور ولا لغي الحجز قبل التسليم. خاصك تكتب السبب.', release: 'لغي الحجز', recover: 'بدل الحجز', reason: 'السبب', reservationSaved: 'الحجز تبدل.',
    acceptPickup: 'قبل هاد الجمع', acceptReturn: 'قبل هاد الإرجاع', accepted: 'الجمع تقبل', releaseReturn: 'خلي هاد الإرجاع لشي واحد آخر', returnReleased: 'هاد الإرجاع ولى متاح لليفرورات الآخرين.',
    acceptHint: 'قبل قبل ما تمشي. هاد الجمع غادي يتحجز ليك.', reservedHint: 'هاد الجمع محجوز ليك. من بعد أكد التسليم بالتصويرة والبلاصة ديالك.',
    senderHandover: 'التسليم من المرسل', senderHandoverHint: 'عيط للمرسل وتأكد من الكولي والمرجع ديالو، ومن بعد أكد بتصويرة والبلاصة ديالك.',
    returnPickup: 'خود الإرجاع', returnDestination: 'رجع الكولي', directReturn: 'الكولي باقي فنقطة الانطلاق. رجعو مباشرة للمرسل بالكود الجديد ديالو.',
    paymentTitle: 'خلاص الإرسالية', paymentDemo: 'تجربة: ما كيتخصم حتى مبلغ حقيقي.',
    paymentHint: 'الخلاص الحقيقي غادي يتزاد من بعد. هاد التجربة كتقبل أي معلومات وكتسجل المصاريف وكتبين الكود بلا ما تاخد فلوس.',
    paymentGateHint: 'هاد التجربة كتقبل أي معلومات وكتبين الكود ديالك من بعد ما تسجل المصاريف. ماكاين حتى خلاص حقيقي.',
    previewPayment: 'شوف فورم الخلاص', cardNumber: 'نمرة الكارط', cardHolder: 'السمية فالكارط', expiry: 'تاريخ الانتهاء', securityCode: 'كود الأمان',
    demoHolder: 'كارط تجريبية', simulatePayment: 'جرب خلاص {amount}', paymentComplete: 'التجربة سالات', paymentCompleteHint: 'ما تخلص حتى مبلغ حقيقي. المصاريف تسجلو غير.',
    payForCode: 'خلص باش يبان ليك الكود', paymentRequired: 'خلص المصاريف باش تاخد كود الإيداع.', paymentReceipt: 'الخلاص التجريبي تسجل فالسجل ديالك.', paymentFailed: 'الخلاص التجريبي ما نجحش. عاود جرب.',
    shipment: 'الكولي', amount: 'المبلغ', back: 'رجع', next: 'اللي من بعد', review: 'راجع',
    originStep: 'المرسل والجمع', recipientStep: 'المستلم', optionsStep: 'تفاصيل الكولي', reviewStep: 'المراجعة',
    senderMap: 'حط العنوان فالخريطة', senderMapHint: 'كليكي على الخريطة ولا حرك العلامة. خلي عنوان واضح للليفرور.',
    locationSelected: 'البلاصة تختارات', change: 'بدل', step: 'الخطوة {current} من {total}',
    pay: {
      secure: 'خلاص آمن',
      summary: 'الملخص',
      fee: 'رسوم الإيداع',
      total: 'المبلغ الكلي',
      method: 'طريقة الخلاص',
      methodCard: 'كارط بنكية',
      methodCardHint: 'Visa وMastercard وCMI',
      appleHint: 'بـ Face ID ولا Touch ID',
      googleHint: 'بحساب Google ديالك',
      paypalHint: 'بحساب PayPal ديالك',
      holderPlaceholder: 'السمية كيف كاينة فالكارط',
      errNumber: 'نمرة الكارط ماشي صحيحة',
      errHolder: 'كتب سمية صاحب الكارط',
      errExpiry: 'تاريخ ماشي صحيح',
      errExpired: 'الكارط سالات',
      errCvc: 'كود ماشي صحيح',
      useDemoCard: 'استعمل الكارط التجريبية',
      demoCardHint: 'كارط تجريبية: 4242 4242 4242 4242 وأي تاريخ جاي وأي كود. النمرة 4000 0000 0000 0002 كتحاكي الرفض.',
      payNow: 'خلص {amount}',
      payWith: 'خلص بـ {method}',
      contacting: 'كنتصلو بالبنك ديالك…',
      securing: 'كنتأكدو بأمان…',
      authenticating: 'كنتأكدو عبر {method}…',
      redirecting: 'كنحولوك لـ PayPal…',
      waitingPaypal: 'كنتسناو موافقة PayPal…',
      processing: 'كنعالجو الخلاص…',
      verifyTitle: 'التحقق 3-D Secure',
      verifyHint: 'دخل الكود ديال 6 د الأرقام اللي صيفطو البنك. فالتجربة أي كود ديال 6 أرقام مقبول.',
      verifyCode: 'كود التحقق',
      verifyConfirm: 'أكد',
      errCode: 'دخل 6 أرقام',
      paypalTitle: 'دخول لـ PayPal',
      paypalIntro: 'دخل باش توافق على هاد الخلاص ديال {amount}.',
      paypalEmail: 'إيميل PayPal',
      errEmail: 'إيميل ماشي صحيح',
      paypalApprove: 'دخل ووافق',
      declined: 'البنك رفض الكارط. جرب وحدة أخرى.',
      receiptTitle: 'تخلص بنجاح',
      receiptHint: 'كود الإيداع واجد.',
      paidWith: 'تخلص بـ',
      transaction: 'العملية',
      date: 'التاريخ',
      showCode: 'بين ليا الكود',
      cardEnding: '{brand} •••• {last4}',
      paypalPaid: 'PayPal · {email}'
    }
  }
}
